import React from "react";
import Tech from "./Tech";

const WorksItems = ({ item }) => {
  console.log(item.technology);
  return (
    <div className="work__card" key={item.id}>
      <img src={item.image} alt="" className="work__img" />
      <h3 className="work__title">{item.title}</h3>
      <div className="flex justify-between mt-4">
        <a
          href={item.github}
          target="_blank"
          rel="noreferrer"
          className="work__button"
        >
          GitHub <i className="bx bx-right-arrow-alt work__button-icon"></i>
        </a>
        <a
          href={item.live}
          target="_blank"
          rel="noreferrer"
          className="work__button"
        >
          View Site <i className="bx bx-right-arrow-alt work__button-icon"></i>
        </a>
      </div>
      <div className="flex mt-10 gap-2">
        {item.technology.map((item) => (
          <Tech text={item}></Tech>
        ))}
      </div>
    </div>
  );
};

export default WorksItems;
